import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './modules/auth';
import current from './modules/current';
import data from './modules/data';
import Cookies from 'js-cookie';

Vue.use(Vuex);

const COOKIE_DOMAIN = process.env.MIX_COOKIE_STORE_DOMAIN;
const COOKIE_NAME = process.env.MIX_COOKIE_STORE_NAME;

export default new Vuex.Store({
    plugins: [
        createPersistedState({
            key: `${COOKIE_NAME}-auth`,
            paths: ["auth"],
            storage: {
                getItem: (key) => Cookies.get(key, { domain: COOKIE_DOMAIN }),
                setItem: (key, value) =>
                    Cookies.set(key, value, {
                        expires: 3,
                        secure: location.protocol === "https:",
                        domain: COOKIE_DOMAIN,
                    }),
                removeItem: (key) => Cookies.remove(key, { domain: COOKIE_DOMAIN }),
            }
        })
    ],
    modules: {
        auth,
        current,
        data
    }
});
